import React from "react";
import { Route } from "react-router-dom";
import Players from "./Players";

const App = () => {
  return (
    <div>
      <Route exact path="/" component={Players} />
      <Route path="/:yr/:rnd" component={Players} />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js